import { createClosingGame } from '../shared/closing-game.js';

// Identical to Cricket, just an extended target range: 10-20 + bull instead
// of 15-20 + bull.
export default createClosingGame({
    id: 'tactics',
    name: 'Tactics',
    description: "Cricket's rules, played across a wider range - 10 through 20 plus the bull, instead of just 15 through 20.",
    getTargets: () => [20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 'bull'],
    soleCloserScoring: true
});
